<template>
    <div id="TextPrompt">
        <div class="content-container text-prompt-container d-flex flex-column align-items-center animate__animated animate__fadeIn">
            <h3 class="pb-5 brand-text align-self-center">{{ prompt.title }}</h3>
            <p class="text-center" :class="{'pb-5': prompt.id !== 'DGB003_under_16'}" v-html="prompt.subtitle"></p>
            <p class="pb-5 text-center" v-if="prompt.id === 'DGB003_under_16'">Lines are open Monday to Friday 8am to 10pm, Saturday and Sunday and Bank Holidays 8am to 5pm.</p>
            <div class="warning-info-container d-flex flex-row justify-content-start align-items-center mt-3" v-if="prompt.alert">
                <i class="fa-solid fa-circle-exclamation fa-3x mr-4"></i>
                <p class="mb-0" v-html="prompt.alert"></p>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    components: {

    },
    name: "component",
    data() {
        return {

        };
    },
    mounted() {
        let eles = document.getElementsByClassName('mobile-only-link');
        if(!this.isMobile() && eles.length !== 0){
            eles[0].removeAttribute('href');
        }
    },
    beforeDestroy() {

    },
    methods: {

    },
    props: ['prompt', 'title', 'body', 'warning', 'cta'],

};
</script>
<style lang="less">
#TextPrompt {
    .text-prompt-container {
        max-width: 700px;
        font-size: 1.6rem;

        h3 {
            padding-top: 0;
            margin-top: 0;
            letter-spacing: normal;
            font-size: 1.8rem;
        }
        a{
            font-weight: 500;
        }
        .mobile-only-link{
            cursor: default;
        }
        .warning-info-container {
            font-family: "Montserrat", serif;
            font-weight: 700;
            background-color: white;
            padding: 20px;
            border: 2px solid #D60023;
            border-radius: 16px;
            margin-bottom: 25px;

            i {
                color: #D60023;
            }
        }

        .btn {
            margin-top: 30px;
            margin-bottom: 100px;
        }
    }
}
</style>